module.exports = __webpack_public_path__ + "0f2fe3d1016a0148d03ea09e3aca440f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/icon-homeService@2x.png
// module id = 1749
// module chunks = 0